import * as firebase from "firebase/app";
import "firebase/messaging";
import "firebase/database";
import "firebase/storage";
import axios from "axios";
import uuidv4 from "uuid/v4";
import moment from "moment";
import _ from "lodash";

import api from "./api";
import actionTypes from "./actionTypes";

// const config = {
//   apiKey: "AIzaSyBzGbcZe5-Q6KjmC3OBrgdOBXF3JNoTkxQ",
//   authDomain: "test-904c1.firebaseapp.com",
//   databaseURL: "https://test-904c1.firebaseio.com",
//   storageBucket: "test-904c1.appspot.com",
// };
const config = {
  apiKey: "AIzaSyBAcpuVVzw_2zRf6lEKc9jFHsvi4SOasq0",
  authDomain: "asap-client.firebaseapp.com",
  databaseURL: "https://asap-client.firebaseio.com",
  projectId: "asap-client",
  storageBucket: "asap-client.appspot.com",
  messagingSenderId: "212468149608",
};

firebase.initializeApp(config);

const updateToken = () => {
  const venueId = window.store.getState().settings.venue_id;
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("../firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Registration successful, scope is:", registration.scope);
        const messaging = firebase.messaging();
        messaging
          .requestPermission()
          .then(() => {
            console.log("Notification permission granted.");
            getToken();
          })
          .catch((err) => {
            console.log("Unable to get permission to notify.", err);
          });

        function getToken() {
          messaging
            .getToken()
            .then((currentToken) => {
              if (currentToken) {
                sendTokenToServer(currentToken);
              } else {
                // Show permission request.
                console.log("No Instance ID token available. Request permission to generate one.");
                // Show permission UI.
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
            });
        }

        function sendTokenToServer(token) {
          console.log("DTDBG: FCMToken", token);
          firebase
            .database()
            .ref(`/FCMTokens/venue${venueId}`)
            .set(token);
        }
      })
      .catch((err) => {
        console.log("Service worker registration failed, error:", err);
      });
  }
};

const database = firebase.database();
const loadGifts = () => {
  const venueId = window.store.getState().settings.venue_id;
  database
    .ref(`/venues/${venueId}`)
    .once("value")
    .then((snapshot) => {
      console.log("DTDBG: snapshot", snapshot.val());
      if (snapshot.val()) {
        window.store.dispatch({
          type: actionTypes.GIFTS_LOADED,
          gifts: snapshot.val(),
        });
      } else {
        database.ref(`/venues/${venueId}/`).set({
          isAvailableVenueSide: false,
          message: "",
          positions: {},
        });
      }
    });
};

const updateVenueName = (venueName) => {
  const venueId = window.store.getState().settings.venue_id;
  database.ref(`/venues/${venueId}/name`).set(venueName);
};

const toogleGiftsAvailable = () => {
  const venueId = window.store.getState().settings.venue_id;
  const isAvailable = window.store.getState().gifts.isAvailableVenueSide;
  database.ref(`/venues/${venueId}/isAvailableVenueSide`).set(!isAvailable);
  window.store.dispatch({
    type: actionTypes.TOGGLE_GIFTS_AVAILABLE,
  });
};

const updateMessage = (message, save = false) => {
  if (save) {
    const venueId = window.store.getState().settings.venue_id;
    database.ref(`/venues/${venueId}/message`).set(message);
  }
  window.store.dispatch({
    type: actionTypes.UPDATE_MESSAGE,
    message,
  });
};

const updateGiftPositions = (giftPositions) => {
  const venueId = window.store.getState().settings.venue_id;
  console.log("DTDBG: giftPositions", giftPositions);
  database.ref(`/venues/${venueId}/positions`).set(giftPositions);
  window.store.dispatch({
    type: actionTypes.UPDATE_GIFT_POSITIONS,
    positions: giftPositions,
  });
};

let listeningChat = "";

const loadMessages = (messagesId, callback) => {
  database.ref(`/messages/${listeningChat}`).off("value");
  listeningChat = messagesId;
  database.ref(`/messages/${listeningChat}`).on("value", (snapshot) => {
    callback(snapshot.val());
  });
};

const selectChat = (userId, callback) => {
  const venueId = window.store.getState().settings.venue_id;
  database.ref(`/chats/venue${venueId}/chats/${userId}`).once("value", (snapshot) => {
    const chatObj = snapshot.val();
    database.ref(`/chats/venue${venueId}/chats/${userId}`).set({
      ...chatObj,
      lastReadAt: firebase.database.ServerValue.TIMESTAMP,
      unreadMessagesCount: 0,
      isHidden: false,
    });
    callback(chatObj);
  });
};

const activateUser = (userId, message, callback) => {
  const { settings, venue, guests } = window.store.getState();
  const venueId = settings.venue_id;
  const venueName = venue.name;
  const adminPhoto = venue.admin.photo;
  const adminName = venue.admin.name;
  const userName = guests.listById[userId].name;
  const userPhoto = guests.listById[userId].photo;
  axios
    .post(
      `https://us-central1-asap-client.cloudfunctions.net/v1/register?fromId=venue${venueId}&toId=${userId}&fromTitle=${adminName},%20${venueName}&toTitle=${userName}&fromPhotoUrl=${adminPhoto}&toPhotoUrl=${userPhoto}&message=${message}`,
      {},
    )
    .then(() => {
      getChatById(userId, callback);
    });
};

const activateSupportUser = (userId, message, callback) => {
  const { settings, venue } = window.store.getState();
  const venueId = settings.venue_id;
  const venueName = venue.name;
  const adminPhoto = venue.admin.photo;
  const adminName = venue.admin.name;
  const userName = "Greg Uspensky";
  const userPhoto = "";
  axios
    .post(
      `https://us-central1-asap-client.cloudfunctions.net/v1/register?fromId=venue${venueId}&toId=${userId}&fromTitle=${adminName},%20${venueName}&toTitle=${userName}&fromPhotoUrl=${adminPhoto}&toPhotoUrl=${userPhoto}&message=${message}`,
      {},
    )
    .then(() => {
      getChatById(userId, callback);
    });
};

const getChatById = (userId, callback) => {
  const venueId = window.store.getState().settings.venue_id;
  database.ref(`/chats/venue${venueId}/chats/${userId}`).once("value", (el) => {
    callback(el.val());
  });
};

const sendMessage = (userId, messagesIds, message = "Empty message :(") => {
  const venueId = window.store.getState().settings.venue_id;
  const messageObj = {
    recipientId: userId,
    senderId: `venue${venueId}`,
    message,
    representativeId: window.store.getState().venue.admin.id,
    isFromBot: false,
    timestamp: firebase.database.ServerValue.TIMESTAMP,
    minimumSupportedVersion: "0.0.0",
    type: "text",
  };
  database.ref(`/messages/${messagesIds}`).push(messageObj);
};

const setNewAdmin = (userId) => {
  const { venue, settings } = window.store.getState();
  const venueId = settings.venue_id;
  const venueName = venue.name;
  const chatPhoto = venue.admin.photo || settings.photo;
  const chatName = venue.admin.name ? `${venue.admin.name}, ${venueName}` : `${venueName}`;
  const updates = {};
  updates[`/chats/${userId}/chats/venue${venueId}/title`] = chatName;
  updates[`/chats/${userId}/chats/venue${venueId}/photoUrl`] = chatPhoto;
  database.ref().update(updates);
};

const readMessages = (userId) => {
  const venueId = window.store.getState().settings.venue_id;
  const updates = {};
  updates[`/chats/venue${venueId}/chats/${userId}/unreadMessagesCount`] = 0;
  database.ref().update(updates);
};

const loadChats = () => {
  const venueId = window.store.getState().settings.venue_id;
  database.ref(`/chats/venue${venueId}/chats`).off("value");
  database.ref(`/chats/venue${venueId}/chats`).on("value", (snapshot) => {
    console.log("DTDBG: snapshot chats", snapshot.val());
    const rawChats = snapshot.val() || {};
    const chats = Object.keys(rawChats).map(key => rawChats[key]);
    console.log("DTDBG: chats", rawChats);
    window.store.dispatch({
      type: actionTypes.LOAD_CHATS,
      chats,
    });
  });
};

const getSupportAgents = () => {
  const venueId = window.store.getState().settings.venue_id;
  database.ref("/supportAgents").off("value");
  database.ref("/supportAgents").on("value", (snapshot) => {
    const rawSupportAgents = snapshot.val();
    const supportAgents = Object.keys(rawSupportAgents).filter(key => rawSupportAgents[key][`venue${venueId}`]);
    api.getSupportAgentsInfo(supportAgents);
  });
};

const setSupportAgents = (newUserIds, currentUserIds) => {
  const venueId = window.store.getState().settings.venue_id;
  const updates = {};
  newUserIds.forEach((id) => {
    updates[`/supportAgents/${id}/venue${venueId}`] = true;
  });
  currentUserIds.forEach((id) => {
    if (newUserIds.indexOf(id) === -1) {
      updates[`/supportAgents/${id}/venue${venueId}`] = null;
    }
  });
  database.ref().update(updates);
};

const getMailings = () => {
  const venueId = window.store.getState().settings.venue_id;
  database
    .ref("/virtualChats")
    .orderByChild("supportId")
    .equalTo(`venue${venueId}`)
    .off("value");
  database
    .ref("/virtualChats")
    .orderByChild("supportId")
    .equalTo(`venue${venueId}`)
    .on("value", (snapshot) => {
      const rawMailings = snapshot.val();
      const mailings = Object.keys(rawMailings || {}).map(key => ({ ...rawMailings[key], key }));
      window.store.dispatch({
        type: actionTypes.LOAD_MAILINGS,
        mailings: _.orderBy(mailings, ["createdAt"], ["desc"]),
      });
    });
};

const addMailing = (
  name,
  message,
  messageMedia,
  isOpenMenuButton,
  isOpenChatButton,
  isFreeTextButton,
  freeText,
  venueAnswerMessage,
  venueAnswerMedia,
) => {
  const venueId = window.store.getState().settings.venue_id;
  const buttons = [];
  let init = {
    type: "text",
    text: message,
  };
  let media = null;
  if (messageMedia.source) {
    init = {
      ...init,
      next: "media",
    };
    media = {
      delay: 1000,
      type: "media",
      media: messageMedia,
    };
  }
  let reply = null;
  let yes = null;
  let answerMedia = null;
  if (isFreeTextButton) {
    buttons.push({ name: freeText, next: "yes" });
    yes = {
      delay: 1000,
      type: "text",
      text: venueAnswerMessage,
    };
    if (venueAnswerMedia.source) {
      yes = {
        ...yes,
        next: "answerMedia",
      };
      answerMedia = {
        delay: 1000,
        type: "media",
        media: venueAnswerMedia,
      };
    }
  }
  let menu = null;
  if (isOpenMenuButton) {
    buttons.push({ name: "Меню", next: "menu" });
    menu = {
      type: "goToVenueMenu",
    };
  }
  let chat = null;
  if (isOpenChatButton) {
    buttons.push({ name: "Чат", next: "chat" });
    chat = {
      type: "goToSupportChat",
    };
  }
  if (buttons.length) {
    reply = {
      type: "reply",
      buttons,
    };
    if (media) {
      media = {
        ...media,
        next: "reply",
      };
    } else {
      init = {
        ...init,
        next: "reply",
      };
    }
  }
  const newMailing = {
    delivery: {
      openCounter: 0,
      sendCounter: 0,
      status: "not send",
    },
    marketing: true,
    createdAt: firebase.database.ServerValue.TIMESTAMP,
    supportId: `venue${venueId}`,
    messages: {
      init,
      media,
      reply,
      yes,
      answerMedia,
      chat,
      menu,
    },
  };
  database.ref("/virtualChats").push(newMailing);
  getMailings();
};

const uploadImage = (file, uploadingCallback, successfulCallback) => {
  const venueId = window.store.getState().settings.venue_id;
  const uploadTask = firebase
    .storage()
    .ref()
    .child(`mailingImages/${venueId}/${uuidv4()}.${file.type.split("/").pop()}`)
    .put(file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      uploadingCallback(progress);
    },
    (error) => {
      console.log("DTDBG: error", error);
      // Handle unsuccessful uploads
    },
    () => {
      successfulCallback(uploadTask.snapshot.downloadURL);
    },
  );
};

const firebaseAuthRequest = (urlSuffix, body) =>
  axios.post(`https://us-central1-asap-client.cloudfunctions.net/v1${urlSuffix}`, body);
const MAILING_TEST_IDS = [301, 362, 437, 3428, 3434, 3729];

const sendMailing = (debug, key) => {
  const venueId = window.store.getState().settings.venue_id;
  return firebaseAuthRequest("/subscribeVenueClientsToTopic", {
    venueId,
    debug,
  }).then(({ data }) => {
    if (data.status === "success") {
      const { guests: { listById } } = window.store.getState();
      const clients = debug ? MAILING_TEST_IDS : Object.keys(listById);
      clients.forEach((id) => {
        database.ref(`/virtualChatsMeta/${id}/virtualChats`).set({
          [key]: moment().unix(),
        });
      });
      return firebaseAuthRequest("/sendToVenueClients", {
        venueId,
        virtualChatId: key,
        debug,
      });
    }
    return null;
  });
};

const fastVirtualChat = (message, media, callback) => {
  const venueId = window.store.getState().settings.venue_id;
  const virtualChat = {
    delivery: {
      openCounter: 0,
      sendCounter: 0,
      status: "not send",
    },
    marketing: true,
    createdAt: firebase.database.ServerValue.TIMESTAMP,
    supportId: `venue${venueId}`,
    messages: {
      init: {
        delay: 1000,
        type: "text",
        text: message,
        next: "reply",
      },
      reply: {
        type: "reply",
        buttons: [{ name: "Ок!" }],
      },
    },
  };
  if (media.source) {
    virtualChat.messages.media = {
      delay: 1000,
      media,
      type: "media",
      next: "reply",
    };
    virtualChat.messages.init = {
      ...virtualChat.messages.init,
      next: "media",
    };
  }
  const newVirtualChatKey = database.ref("/virtualChats").push(virtualChat).key;
  return setTimeout(() => sendMailing(false, newVirtualChatKey).then(() => callback()), 2000);
};

export default {
  loadGifts,
  updateGiftPositions,
  updateMessage,
  toogleGiftsAvailable,
  loadMessages,
  selectChat,
  sendMessage,
  getChatById,
  activateUser,
  setNewAdmin,
  loadChats,
  readMessages,
  getSupportAgents,
  setSupportAgents,
  updateToken,
  getMailings,
  addMailing,
  uploadImage,
  updateVenueName,
  sendMailing,
  fastVirtualChat,
  activateSupportUser,
};



// WEBPACK FOOTER //
// ./src/firebaseApi.js